//const base_url = "http://50.18.104.181:8080/codeisfun";
//const base_url = "https://api.codeisfun.com/codeisfun";
const base_url = "/codeisfun";
export default base_url;
